import { storeToRefs } from 'pinia'
import useUserStore from '@/stores/userInfo'

function checkPermission(el, binding) {
  // 获取绑定的值，此处为权限
  const { value } = binding
  const { pagePermission, btnPermission } = storeToRefs(useUserStore())

  // console.log(value)
  if (value) {
    // 判断page，即页面中的tab是否有权限
    if (value[0] === 'page') {
      const hasPermission = pagePermission.value.some((point) => {
        return value[1].includes(point) // 有就true
      })
      if (!hasPermission) {
        // console.log(el.parentNode, '0000000')
        el.parentNode && el.parentNode.removeChild(el)
        // el.parentNode && el.parentNode.removeChild(el)
      }
    }
    // 判断页面中的按钮权限
    if (value[0] === 'btn') {
      const hasPermission = btnPermission.value.some((point) => {
        return value[1].includes(point) // 有就true
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}

export default {
  // 在绑定元素的父组件被挂载后调用
  mounted(el, binding) {
    checkPermission(el, binding)
  },
  // 在包含组件的 VNode 及其子组件的 VNode 更新后调用
  update(el, binding) {
    checkPermission(el, binding)
  }
}
